import { useEffect, useRef } from 'preact/hooks';
import { useMutation } from "@apollo/client";
import UPDATE_CHECKOUT_MUTATION from '@/mutations/updateCheckout';
import useLocalStorageState from "use-local-storage-state";

export default function useUpdateCheckout() {
	const [retailerObject, setRetailerObject] = useLocalStorageState("dutchie_retailer");
	const retailerId = retailerObject?.id;
	const retailerSlug = retailerObject?.slug;
	const [checkoutId, setCheckoutId] = useLocalStorageState("dutchie_checkout_" + retailerSlug);
	const [orderType, setOrderType] = useLocalStorageState('cp_fulfillment_type');
	const [updateCheckout, { loading: loading, error: mutationError, data: dataError }] = useMutation( UPDATE_CHECKOUT_MUTATION, {
		variables: {
			orderType: orderType,
			pricingType: "RECREATIONAL",
			retailerId: retailerId,
			checkoutId: checkoutId,
		}
	} );

	const didMount = useRef(false);

	useEffect(() => {
		//dont run on every render or page load, only when orderType changes
		if ( didMount.current && orderType && checkoutId ) {
			updateCheckout();
		} else {
			didMount.current = true;
		}
	}, [orderType]);

	function updateCheckoutType(fulfillmentType) {
		switch( fulfillmentType ) {
			case 'pickup':
				fulfillmentType = 'PICKUP';
				break;
			case 'delivery':
				fulfillmentType = 'DELIVERY';
				break;
			case 'kiosk':
				fulfillmentType = 'KIOSK';
			case 'driveThruPickup':
				fulfillmentType = 'DRIVE_THRU_PICKUP';
				break;
			case 'curbsidePickup':
				fulfillmentType = 'CURBSIDE_PICKUP';
				break;
		}

		setOrderType(fulfillmentType);
	}

	return { updateCheckoutType }
}